import { Directive, Input } from '@angular/core';
import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[passwordConfirm]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PasswordConfirmDirective,
    multi: true,
  }]
})
export class PasswordConfirmDirective implements Validator {

  constructor() {
  }
  validate(control: FormGroup): ValidationErrors {
    const passwordControl = control.controls.password;
    const confirmPasswordControl = control.controls.confirmPassword;
    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    if ((confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch)) {
      return null;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      return { 'passwordMismatch': true };
    }
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }

}
